import styled from 'styled-components/macro';

export const OrderListItem = styled.div`
  padding: 5px 15px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
`;

export const OrderListItemName = styled.span`
  text-align: left;
  text-decoration: ${({ through }) => (through ? 'line-through' : 'none')};
`;
